import { fetchCustomersByEmail } from "../api/customerAPI";
import { AuthApiService } from "./authService";
import { FetchCartByCustomerId, updateCartByCustomerId } from "../api/cartApi";
import { blockInventoryApi, unblockInventoryApi } from "../api/inventoryAPI";

export type OrderDetail = {
  id: string;
  orderQuantity: number;
  productId: string;
  unit: number;
};

export type Order = {
  orderDetails: OrderDetail[];
};

export const getCartByCustomerId = async () => {
  try {
    const user = await fetchCustomer();
    const response = await FetchCartByCustomerId({ customerId: user.id });
    const cartData = response?.data?.data?.cart;
    return cartData;
  } catch (error: any) {
    console.log("error", error.message);
    throw new Error(error.message);
  }
};

export const updateCartByCustomerIdService = async (data: any) => {
  try {
    const user = await fetchCustomer();
    const response: any = await updateCartByCustomerId({
      customerId: user.id,
      cartData: data?.cartData ? data.cartData : [],
      deletedProductsFromCart: data?.deletedProductsFromCart
        ? data?.deletedProductsFromCart
        : [],
    });
    const cartData = response?.data?.data?.updatedCart;
    return cartData;
  } catch (error: any) {
    console.log("error", error.message);
    throw new Error(error.message);
  }
};

export const fetchCustomer = async () => {
  try {
    const idToken = await AuthApiService.fetchIdTokenFromCognitoSession();
    const { userEmail } = await AuthApiService.getUserEmail(idToken);
    const userData = await fetchCustomersByEmail({
      emailId: userEmail,
    });
    const user = userData?.customer ?? "";
    return user;
  } catch (error: any) {
    console.log("Error", error.message);
    throw new Error(error.message);
  }
};

export const blockInventoryService = async (orderData: Order) => {
  try {
    await blockInventoryApi(orderData);
    return true;
  } catch (error: any) {
    console.log("error in blockInventoryService", error.message);
    throw new Error(error.message);
  }
};

export const unblockInventoryService = async (orderData: Order) => {
  try {
    await unblockInventoryApi(orderData);
    return true;
  } catch (error: any) {
    console.log("error in blockInventoryService", error.message);
    throw new Error(error.message);
  }
};
